<script>
	export default {
		name: 'ProductExecuter',
		computed: {
			serverDataProducts() {
				return true
			}
		}
	}
</script>